/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import { defineComponent, ref, onMounted, h } from 'vue';
import { textProps } from './props.js';
import '@babel/runtime/helpers/defineProperty';
import './utils/uid.js';
import './constant.js';

var Text = defineComponent({
  name: "Text",
  inheritAttrs: false,
  props: textProps,
  setup: function setup(props2) {
    var sparklineText = ref(null);
    onMounted(function () {
      var text = sparklineText.value;
      var textBox = text && text.getBBox();

      if (textBox) {
        text.setAttribute("x", "".concat(textBox.x - textBox.width / 2));
        text.setAttribute("y", "".concat(props2.margin + textBox.height / 2));
      }
    });
  },
  render: function render() {
    var point = this.point,
        text = this.text,
        textStyles = this.textStyles;
    var x = point.x,
        y = point.y;
    return h("g", [h("text", {
      style: textStyles,
      x: x,
      y: y,
      ref: "sparklineText"
    }, text)]);
  }
});

export { Text as default };
//# sourceMappingURL=Text.js.map
